import React, {useState} from 'react';
import {useProfileStore} from "../../store/profile/pofile.store";
import Chat from "../../components/ui/Chat/ChatCard";
import './Chats.scss';
import PersonalChat from "../PersonalChat/PersonalChat";
import {useCurrentChatStore} from "../../store";
import {Search, Sparkles, FileArchive, UserRound, AudioLines} from "lucide-react";
import {useNavigate} from "react-router-dom";
import Button from "../../components/ui/Button/Button";

const onboardingSteps = [
    {icon: <FileArchive size={18}/>, title: 'Export a chat', text: 'From WhatsApp (.zip or .txt) or Telegram (.json or .html)'},
    {icon: <UserRound size={18}/>, title: 'Pick the person', text: 'Their style and memories shape the replies'},
    {icon: <AudioLines size={18}/>, title: 'Add their voice', text: 'A 10+ second voice message is enough'},
];

const EmptyChats = () => {
    const navigate = useNavigate();
    return (
        <div className="EmptyChats">
            <div className="card EmptyChats__card">
                <div className="icon-tile icon-tile--gradient EmptyChats__icon"><Sparkles size={26}/></div>
                <h3>Create your first AI chat</h3>
                <p>Bring someone's way of texting back to life from a real chat history. It takes about two minutes.</p>

                <ol className="EmptyChats__steps">
                    {onboardingSteps.map((step, idx) => (
                        <li key={step.title}>
                            <div className="icon-tile">{step.icon}</div>
                            <div>
                                <span className="EmptyChats__stepTitle">{idx + 1}. {step.title}</span>
                                <span className="EmptyChats__stepText">{step.text}</span>
                            </div>
                        </li>
                    ))}
                </ol>

                <Button type={'button'} variant={'primary'} title={'Create a chat'}
                        onClick={() => navigate('/create-new-chat')}/>
            </div>
        </div>
    );
};

const Chats = () => {

    const {user} = useProfileStore()
    const {currentChat} = useCurrentChatStore();
    const [search, setSearch] = useState('');

    const chats = user?.chats || [];
    const query = search.trim().toLowerCase();
    const filteredChats = query
        ? chats.filter((el) => `${el?.chat_name} ${el?.person_to_copy}`.toLowerCase().includes(query))
        : chats;

    if (!chats.length) {
        return <div className="ChatLayout"><EmptyChats/></div>;
    }

    return (
        <div className="ChatLayout">
            <aside className="Chats">
                <div className="Chats__header">
                    <h3>Your chats <span>{chats.length}</span></h3>
                    {
                        chats.length > 3 && <label className="Chats__search">
                            <Search size={16}/>
                            <input value={search} onChange={(e) => setSearch(e.target.value)}
                                   placeholder="Search chats" aria-label="Search chats"/>
                        </label>
                    }
                </div>

                <div className="Chats__list">
                    {
                        filteredChats.map((el) => (
                            <Chat data={el} key={el?.bot_id}></Chat>
                        ))
                    }
                    {
                        !filteredChats.length && <span className="Chats__noResults">No chats match "{search}"</span>
                    }
                </div>
            </aside>
            <PersonalChat chatData={currentChat}/>
        </div>
    );
};

export default Chats;
